<template>
  <!-- 大会嘉宾 -->
  <div class="guest">
      <ul class="jiabing">
        <li v-for="(item, index) in speakersList" :key="index" @click="speakersDetail(item)">
          <img :src="item.photoImgUrl" alt="">
          <div class="text">
            <span class="big ellipsis1">{{ item['name' + En] }}</span>
            <span class="small ellipsis1">{{ item['company' + En] }}</span>
            <span class="small ellipsis1">{{ item['position' + En] }}</span>
          </div>
        </li>
      </ul>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="pageNum"
        :page-size="10"
        :layout="pageLayout"
        :pager-count="isPc ? 7 : 3"
        :total="total">
      </el-pagination>
      <speakersDialog
        :showSpeakersModal.sync="showModal"
        :guestDetail="guestDetail"
        @closeModal="closeModal"
      ></speakersDialog>
    </div>
</template>
<script>
import protal from "@/api/protal";
import { againGroup } from "@/common/common";
import speakersDialog from "@/components/speakersDialog.vue";

export default {
  components: {
    speakersDialog
  },
  props: {
    yearUuid: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      total: 0,
      pageNum: 1,
      showModal: false,
      guestDetail: {},
      speakersList: [],
      speakersListwap: [],
      swiperOptions5: {
        loop: true,
        // autoplay: {
        //   delay: 3000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: true,
        // },
        // 播放的速度
        speed: 1000,
        //分页器设置
        pagination: {
          el: ".swiper-pagination5",
          clickable: true,
        }
      },
      swiperOptions5wap: {
        loop: true,
        // autoplay: {
        //   delay: 3000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: true,
        // },
        // 播放的速度
        speed: 1000,
        //分页器设置
        pagination: {
          el: ".swiper-pagination5wap",
          clickable: true,
        }
      },
    };
  },
  watch: {
    yearUuid: {
      handler(v) {
        if (v) {
          this.getData()
        }
      },
      immediate: true
    }
  },
  methods: {
    handleCurrentChange(v) {
      this.pageNum = v
      this.getData()
    },
    forumClick() {
      // this.$router.push('/forum#speakers')
    },
    speakersDetail(item) {
      this.showModal = true;
      this.getInfo(item.uuid)
    },
    getInfo(uuid) {
      protal.queryOfficialFrontGuest(uuid).then(res => {
        this.guestDetail = res.data || {}
      })
    },
    closeModal() {
      this.showModal = false;
    },
    getData() {
      // 活动嘉宾
      protal
        .queryOfficialSpeechGuestList({
          pageNum: this.pageNum,
          pageSize: 10,
          yearUuid: this.yearUuid,
          recommendSts: 0
        })
        .then((res) => {
          this.total = res.total
          if (res && res.data && res.data.length) {
            this.speakersList = res.data
          } else {
            this.speakersList = []
          }
        });
    }
  }
};
</script>

<style lang="less" scoped>

@media screen and (min-width: 769px) {
    .guest {

      .jiabing {
        display: flex;
        flex-wrap: wrap;

        li {
          width: 2.32rem;
          height: 3.98rem;
          border-radius: 1.16rem;
          background: linear-gradient(175deg, #3099F5 0%, rgba(196, 2, 228, 0.5) 100%);
          margin-right: .5rem;
          cursor: pointer;
          margin-bottom: .4rem;

          &:nth-of-type(5n) {
            margin-right: 0;
          }

          img {
            width: 100%;
            height: 2.32rem;
            border-radius: 1.16rem;
            border: .1rem solid rgba(255, 255, 255, .2);
            display: block;
          }

          .text {
            padding: .16rem .28rem 0;

            .big {
              font-size: .22rem;
              color: #fff;
              display: block;
              font-family: sybold;
              margin-bottom: .12rem;
            }

            .small {
              font-size: .18rem;
              line-height: .23rem;
              display: block;
              color: rgba(255, 255, 255, .9);
            }
          }
        }
      }
    }
}
@media screen and (max-width: 768px) {
    .guest {
      .jiabing {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 0 .08rem;

        li {
          width: 3.16rem;
          height: 5.4rem;
          border-radius: 1.58rem;
          background: linear-gradient(175deg, #3099F5 0%, rgba(196, 2, 228, 0.5) 100%);
          cursor: pointer;
          margin-bottom: .38rem;

          img {
            width: 100%;
            height: 3.16rem;
            border-radius: 50%;
            border: .14rem solid rgba(255, 255, 255, .2);
            display: block;
          }

          .text {
            padding: .22rem .36rem 0;

            .big {
              font-size: .32rem;
              line-height: 1.5;
              color: #fff;
              display: block;
              font-family: sybold;
              margin-bottom: .12rem;
            }

            .small {
              font-size: .24rem;
              line-height: .32rem;
              display: block;
              color: rgba(255, 255, 255, .9);
            }
          }
        }
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/wangjie/jiabing.vue